import {filter, isEmpty, keys, map, sortBy} from 'lodash';
import {Fragment, useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Divider} from 'components';
import {SessionResultInformationDetails} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.USER.ACTIVITY.SESSION_RESULT_INFORMATION_DETAILS;

type Props = {
    header?: string;
    sessionResultInformationDetails: SessionResultInformationDetails;
}

export const SessionsResultInformation = (({header, sessionResultInformationDetails}: Props) => {
    const {t} = useTranslation();
    const renderUnsuccessfulSessionsStatisticRows = useCallback((rows: {title: string, value: number}[]) =>
        map(sortBy(rows, (row) => -row.value), ({title, value}) => (
            <div key={title} className='tw-flex tw-justify-between tw-my-2'>
                <span className='tw-break-all'>{title}</span>
                <span>{value}</span>
            </div>
        )), []);

    const [noStatusRows, setNoStatusRows] = useState([]);
    const [withStatusRows, setWithStatusRows] = useState([]);

    useEffect(() => {
        let newNoStatusRows = [];
        let newWithStatusRows = [];
        if (sessionResultInformationDetails) {
            const {finishedBySystem, noStatus} = sessionResultInformationDetails;
            const hasNoStatusRow = finishedBySystem || noStatus;
            if (hasNoStatusRow) {
                newNoStatusRows = filter([
                    {title: t(T_KEYS.FINISHED_BY_SYSTEM), value: finishedBySystem},
                    {title: t(T_KEYS.NO_STATUS), value: noStatus},
                ], (row) => row.value);
            }
            if (!isEmpty(sessionResultInformationDetails.statuses)) {
                newWithStatusRows = keys(sessionResultInformationDetails.statuses).map((status: string) =>
                    ({title: status, value: sessionResultInformationDetails.statuses[status]}));
            }
        }
        setNoStatusRows(newNoStatusRows);
        setWithStatusRows(newWithStatusRows);
    }, [sessionResultInformationDetails, t]);

    if (!sessionResultInformationDetails) {
        return null;
    }

    return (
        <Fragment>
            {header && <div className='tw-ts-sub-header tw-mb-4'>{header}</div>}
            {renderUnsuccessfulSessionsStatisticRows(noStatusRows)}
            {!isEmpty(noStatusRows) && !isEmpty(withStatusRows) && <Divider />}
            <div>
                {renderUnsuccessfulSessionsStatisticRows(withStatusRows)}
            </div>
            {isEmpty(noStatusRows) && isEmpty(withStatusRows) && <div>{t(T_KEYS.NO_DATA)}</div>}
        </Fragment>
    );
});
